const $ = require('jquery');
const rwdImageMaps = require('./src/utils/rwd-image-maps');

export const onInitialClientRender = () => {
  $(document).ready(function () {
    $.ajaxSetup({
      crossDomain: true,
      dataType: 'json',
      cache: false,
    });

    $('img[usemap]').rwdImageMaps();
  });
}
